<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-layout>
      <v-flex>
        <v-container fluid v-if="organisationType !== 'GOVERMENT' &&
                  organisationType !== 'COOP BANK'">
          <v-card class="pa-3">
            <v-row>
              <v-col cols="4" class="text-left">
                <h5>Grower Name:  {{ name }}</h5>
              </v-col>
              <v-col cols="4" class="text-right">
                <h5>Grower Code:  {{ code }}</h5>
              </v-col>
              <!-- if coop maker select grower <select v-model="selectedGrowerCode" id="grower-code">
                <option disabled value="">Select Grower Code</option>
                <option v-for="code in growerCodes" :key="code" :value="code">{{ code }}</option>
              </select> -->
            </v-row>
          </v-card>
        </v-container>

        <v-card>
          <v-tabs
            v-model="selectedTab"
            class="no-border-tabs"
          >

            <v-tab value="1" key="stockDetailStatusTracker">Stock Details Status Tracker</v-tab>
            <v-tab value="2" key="stockStatusGrade">Stock Status Grade</v-tab>
            <v-tab value="3" key="stockStatusSummery">Stock Status Summery</v-tab>

          </v-tabs>

          <v-tabs-items v-model="selectedTab">
            <v-tab-item key="stockDetailStatusTracker">
              <stock-detail-status-tracker2/>
            </v-tab-item>
            <v-tab-item key="stockStatusGrade">
              <stock-status-grade2/>
            </v-tab-item>
            <v-tab-item key="stockStatusSummery">
              <stock-status-summary2/>
            </v-tab-item>

          </v-tabs-items>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import stockDetailStatusTracker from '@/components/views/grower/stockDetailStatusTracker.vue'
import stockStatusGrade from '@/components/views/grower/stockStatusGrade.vue'
import stockStatusSummery from '@/components/views/grower/stockStatusSummery.vue'
import StockDetailStatusTracker2 from '@/components/views/grower/stockDetailStatusTracker2.vue'
import StockStatusGrade2 from '@/components/views/grower/stockStatusGrade2.vue'
import StockStatusSummary2 from '@/components/views/grower/stockStatusSummary2.vue'
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'growerstockdetails',
	components: {
		StockStatusSummary2,
		StockStatusGrade2,
		StockDetailStatusTracker2,
		stockDetailStatusTracker,
		stockStatusGrade,
		stockStatusSummery
	},
	data: function () {
		return {
			selectedTab: null,
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			growerCodes: [],
			seasons: [],
			code: '',
			name: '',
			messsage: '',
			theUser: [],
      organisationType: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		// this.getGrowerCodes()
		// this.getSeasons()
		this.getOrg()
		// console.log('User Organisation :  ==> '+JSON.stringify(store.state.user.userOrganisations[0].id.organisationId))
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
      this.organisationType = this.theUser.organisation.organisationType.name
      console.log('user2 ===>> ', this.organisationType)
			// this.curUserN = this.curUser.firstName
		},
		getSeasons () {
			this.seasons.push('2023/2024')
			this.seasons.push('2024/2025')
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},
		getGrowerCodes () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					// this.growerCodes = response.data
					response.data.forEach(x => {
						// console.log('->> ', x.organisationCode)
						this.growerCodes.push(x.organisationCode)
					})
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.growerCodes
		},
		getOrg () {
			const url = config.serverURI + '/growerstatus/org'
			axios.get(url, {})
				.then(response => {
					this.code = response.data.code
					this.name = response.data.name
					console.log('Organisation Code===>' + this.code + ' Name==> ' + this.name)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.grower
		}
	}
}

</script>
<style scoped>
</style>
